<template>
  <div v-loading="loading" class="zczhcxBody">
    <div class="_title">
      <p class="_title_info">注册账号查询</p>
    </div>
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-position="right"
      class="_jbxxForm"
      label-width="200px"
    >
      <el-form-item label="单位名称：" prop="dwmc">
        <el-input v-model="searchForm.dwmc" />
      </el-form-item>
      <el-form-item label="统一社会信用代码：" prop="shtyxydm">
        <el-input v-model="searchForm.shtyxydm" />
      </el-form-item>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="submit"> 确 认 </el-button>
      </div>
    </el-form>
    <el-descriptions v-if="localData" class="descriptions" title="查询结果" :column="1" :size="size" border>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user" />
          用户名
        </template>
        {{ localData.xm }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone" />
          手机号
        </template>
        {{ localData.sjh }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building" />
          单位名称
        </template>
        {{ localData.dwmc }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building" />
          信用代码
        </template>
        {{ localData.shtyxydm }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-office-building" />
          单位状态
        </template>
        {{ localData.statusLabel }}
      </el-descriptions-item>
    </el-descriptions>

  </div>
</template>

<script>
import { getZxxyInfo } from '@/assets/js/system.js'
export default {
  name: 'Zczhcx',
  data() {
    return {
      loading: false,
      searchForm: {
        dwmc: '',
        shtyxydm: ''
      },
      localData: false,
    }
  },
  methods: {
    reset() {
      this.searchForm = { dwmc: '', shtyxydm: '' }
      this.localData = false
    },
    submit() {
      if (!this.searchForm.shtyxydm && !this.searchForm.dwmc) {
        this.$message('单位名称与统一信用代码必填一个')
        return
      }
      this.loading = true
      getZxxyInfo(this.searchForm)
        .then((e) => {
          this.loading = false
          if (e.status === 200) {
            this.localData = e.data.data
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang='less' scoped>
.zczhcxBody {
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 100px auto 0px auto;
    width: 50%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 50px auto 0px auto;
    width: 50%;
  }
}
.descriptions {
    width: 70%;
    margin: 0 auto;;
}
</style>
